import TiresPage from 'pages/TiresPage/TiresPage';

export default TiresPage;
